import {Locales} from '@netx/core-next/locales/utils/Locales';
import type {ErrorTranslations, ServerError} from '@netx/core/typings';

export const ASSET_ERROR_CODE = <const>{
	OBJECT_NOT_FOUND: 4003,
};

export const ASSET_READ_ERROR_CODES = [ASSET_ERROR_CODE.OBJECT_NOT_FOUND];

export const ASSET_ERRORS: ServerError<typeof ASSET_ERROR_CODE> = <const>{
	OBJECT_NOT_FOUND: {
		code: ASSET_ERROR_CODE.OBJECT_NOT_FOUND,
		message: `Object not found (AssetBean does not exist)`,
	},
};

export const assetErrors = Locales((i18n) => ({
	read: {
		default: i18n('i18n.errorRequestFailed'),
		...ASSET_READ_ERROR_CODES.reduce(
			(errors, code) =>
				Object.assign(errors, {
					[code]: i18n(`i18n.errorAssetAction_${code}`),
				}),
			{} as ErrorTranslations<typeof ASSET_ERROR_CODE, true>,
		),
	},
}));

export const getAssetError = (
	type: keyof typeof assetErrors,
	code?: number,
) => {
	const errorType = assetErrors[type];
	return errorType[code as keyof typeof errorType] || assetErrors[type].default;
};
